import type { Optional } from '@festina-life/core'
import type { ReactNode } from 'react'

import { createRequiredContext } from '../../libs/context'
import type { TreeLeafData, TreeNodeData } from './types'

export type CommonTreeProps = {
  containerRef: Optional<HTMLElement>
  renderTags?: (attributes: string[]) => ReactNode
  id: string
  nodeClassName?: Optional<
    string | ((node: TreeNodeData<TreeLeafData>) => Optional<string>)
  >
  leafClassName?: Optional<string | ((leaf: TreeLeafData) => Optional<string>)>
  isVisible?: boolean
}

type TreeContextProps = CommonTreeProps & {
  trees: TreeNodeData<TreeLeafData>[]
  renderNode?: (node: TreeNodeData<TreeLeafData>) => ReactNode
  renderNodeActions?: (node: TreeNodeData<TreeLeafData>) => ReactNode
  renderLeafActions?: (node: TreeLeafData) => ReactNode
  renderLeaf: (leaf: TreeLeafData) => ReactNode
  onTogglePath: (path: string) => void
  expandedPaths: string[]
  onSelectNode?: (node: TreeNodeData<TreeLeafData>) => void
  onSelectLeaf?: (leaf: TreeLeafData) => void
  shouldSortNodes?: boolean
}

const [useTreeContext, Provider] =
  createRequiredContext<TreeContextProps>('Tree')

export { Provider, useTreeContext }
